module.exports = __webpack_public_path__ + "media/images/stream_preview_portrait-275d155274412c437c2f7e48635106a9.png";